import { render, staticRenderFns } from "./customer-sample-requests.vue?vue&type=template&id=5c39ba00"
import script from "./customer-sample-requests.vue?vue&type=script&lang=js"
export * from "./customer-sample-requests.vue?vue&type=script&lang=js"
import style0 from "./customer-sample-requests.vue?vue&type=style&index=0&id=5c39ba00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports